import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import type {SxProps} from '@mui/system';
import type {FC} from 'react';
import {Outlet} from 'react-router-dom';
import About from '@/components/common/About';
import LazyLoading from '@/components/common/LazyLoading';
import Profile from '@/components/common/Profile';
import {useController} from './controller';

const FloatingOnTopLayout: FC = () => {
  const {user, loading, app_hash, app_version, app_timestamp, onLogout} = useController();

  if (loading || !user) {
    return <LazyLoading />;
  }

  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.content}>
        <Outlet />
      </Box>
      <Stack sx={styles.config}>
        <Profile user={user} onLogout={onLogout} />
        <About hash={app_hash} version={app_version} timestamp={app_timestamp} />
      </Stack>
    </Box>
  );
};
export default FloatingOnTopLayout;

const styles: Record<string, SxProps> = {
  wrapper: {
    margin: {xs: '8px 8px 80px 8px', sm: '8px 8px 100px 8px', lg: '16px 16px 135px 16px'},
    flex: 1,
    display: 'flex',
    backgroundColor: 'background.semiTransparent',
    maxWidth: '100%',
    height: '100%',
    padding: {xs: '1rem', md: '2rem'},
    borderStyle: 'double',
    borderWidth: '6px',
    borderColor: 'primary.main',
    minWidth: 0,
    minHeight: 0,
    overflow: 'hidden',
    overflowX: 'hidden',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    minWidth: 0,
  },
  config: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    position: 'absolute',
    bottom: '10px',
    right: '10px',
    zIndex: 500,
  },
};
